import { useState, useEffect } from "react";
import { SportsMap, SportsMapInv } from "./SportMap";
import { useQuery } from "@tanstack/react-query";

import { Spinner } from "flowbite-react";
import { Link, useParams } from "react-router-dom";

const fetchSport = async (sport) => {
  let resp;
  if (sport === undefined) {
    resp = await fetch("/api/sport", {
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    });
  } else {
    resp = await fetch(`/api/sport/${sport}`, {
      method: "GET",
      headers: {
        "content-type": "application/json",
      },
    });
  }
  if (!resp.ok) {
    throw new Error("Could not fetch list of sports");
  }

  return resp.json();
};

export const isSportSupported = (s) => {
  if (!SportsMapInv.hasOwnProperty(s)) {
    return false;
  }
  let name = SportsMapInv[s];
  if (!SportsMap.hasOwnProperty(name)) {
    return false;
  }
  return true;
};
export const GetAllSports = () => {
  const {
    data: sports,
    isLoading,
    isError,
  } = useQuery({ queryKey: ["sports"], queryFn: async () => fetchSport() });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner size="xl" />
      </div>
    );
  }

  if (isError || !sports) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-500">Could not fetch list of sports</p>
      </div>
    );
  }

  const sportList = sports.filter((s) => isSportSupported(s));
  const smap = sportList.map((s) => SportsMapInv[s]);
  return (
    <div className="flex flex-col justify-around max-w-8xl min-w-full">
      <div className="columns-auto lg:columns-2 2xl:columns-3">
        {smap.map((key) => {
          return (
            <Link key={key} to={`/Sport/${key}`}>
              <div className="md:px-8 md:py-4 group">
                <div
                  className="rounded-lg border flex mx-auto min-w-full sm:min-w-[480px] min-h-[240px] bg-cover break-inside-avoid-column transition group-hover:backdrop-blur-md group-hover:backdrop-grayscale"
                  style={
                    SportsMap[key].picture !== undefined
                      ? { backgroundImage: `url(${SportsMap[key].picture})` }
                      : { backgroundColor: "rgba(128, 0, 0, 0.75)" }
                  }
                >
                  {/*<div className="px-4 py-2 md:px-20 md:py-12 text-white font-bold text-xl drop-shadow-lg"> */}
                  <div className="px-4 bottom-1 inset-x-0 text-slate-50 font-bold text-xl drop-shadow-lg">
                    {key}{" "}
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export const GetSport = () => {
  const sport = useParams().id;
  const {
    data: sportData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["sportData", sport],
    queryFn: async () => fetchSport(SportsMap[sport].apiname),
  });

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner size="xl" />
      </div>
    );
  }

  if (isError || !sportData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-red-500">Could not fetch teams</p>
      </div>
    );
  }
  document.title = "NILO - " + sport;
  // Get a Map that maps teams to conferences that they belong to.
  let sportMap = Object();
  for (let i = 0; i < sportData.length; i++) {
    if (sportData[i].conference in sportMap) {
      sportMap[sportData[i].conference].push(sportData[i]);
    } else {
      sportMap[sportData[i].conference] = Array(sportData[i]);
    }
  }

  return (
    <div className="justify-center sm:mx-auto">
      <div className="sm:max-w-fit">
        {Object.entries(sportMap).map(([confName, teams]) => {
          return (
            <div className="my-2 sm:my-10" key={confName}>
              <div className="font-bold">{confName}</div>
              <hr className="h-1" />
              <div className="max-w-7xl sm:my-4 py-auto sm:columns-4 sm:gap-16">
                {teams.map((team) => {
                  return (
                    <div key={team.nilo_id} className="py-3">
                      <Link to={`/Team/${team.nilo_id}`}>{team.name}</Link>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
